import React from 'react';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';
import './DatePicker.scss';
import 'react-datepicker/dist/react-datepicker.css';

function CustomIcon({ onClick }: { onClick?: () => void; }) {
    return (
        <button className="ew-datepicker-iconCalendar" onClick={onClick}>
            <i className="fal fa-calendar" />
        </button>
    );
}

interface DatePickerProps extends ReactDatePickerProps {
    className?: string;
    placeholder?: string;
}

/**
 * DatePicker component for selecting dates with a calendar interface
 * 
 * This component wraps react-datepicker with custom styling and configuration
 * optimized for the Easy Weddings design system. It provides a user-friendly
 * calendar interface with dropdowns for month and year selection.
 * 
 * @param className - Additional CSS classes to apply to the input
 * @param placeholder - Placeholder text for the input field
 * @param rest - All other props from ReactDatePickerProps
 * 
 * @example
 * ```tsx
 * import { useState } from 'react';
 * 
 * // Basic date picker
 * const [selectedDate, setSelectedDate] = useState<Date | null>(null);
 * 
 * <Input.Date
 *   selected={selectedDate}
 *   onChange={(date) => setSelectedDate(date)}
 *   placeholder="Select a date"
 * />
 * ```
 */
const DatePicker = ({ className, placeholder, ...rest }: DatePickerProps) => {
    return (
        <div className="ew-datepicker">
            <ReactDatePicker
                toggleCalendarOnIconClick
                placeholderText={placeholder}
                className={`ew-input ${className || ''}`}
                icon={<CustomIcon />}
                showMonthDropdown
                showYearDropdown
                showIcon
                dateFormat="dd/MM/yyyy"
                dropdownMode="select"
                calendarIconClassname="ew-datepicker-iconCalendar"
                allowSameDay
                {...rest}
            />
        </div>
    );
};

export default DatePicker;
